<router-outlet></router-outlet>







@if(loading()) {
<p-blockUI [blocked]="loading()"
    ><p-progressSpinner></p-progressSpinner
></p-blockUI>
}
